import { WorkoutSort } from '../../context/filter-context'
import { WORKOUT_SORT_BY_TOKEN, WORKOUT_SORT_TOKENS, WorkoutSortToken, sortToToken } from '../../util/workout-query-params'
import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger } from 'src/component/ui/select'
import { cn } from 'src/lib/utils'

// Labels + display order for the Sort By tokens (GH-754). The token → WorkoutSort mapping itself lives
// in workout-query-params (the single source shared with the URL), so this only adds presentation.
const SORT_LABELS: Record<WorkoutSortToken, string> = {
  newest: 'Newest First',
  popular: 'Most Popular',
  'title-asc': 'Title (A-Z)',
  'title-desc': 'Title (Z-A)',
}

interface SortByDropdownProps {
  value: WorkoutSort
  onChange: (sort: WorkoutSort) => void
}

export const SortByDropdown = ({ value, onChange }: SortByDropdownProps): React.ReactElement => {
  const selectedKey = sortToToken(value)

  return (
    <Select value={selectedKey} onValueChange={(key) => onChange(WORKOUT_SORT_BY_TOKEN[key as WorkoutSortToken])}>
      <SelectTrigger
        aria-label="Sort By"
        className={cn(
          // Pill trigger, copper label + chevron (chevron flip-up on open comes from the primitive).
          'h-10 w-auto justify-center gap-2 rounded-full px-3 py-1.5',
          'font-roboto font-semibold normal-case text-primary',
        )}
      >
        <span>Sort By</span>
      </SelectTrigger>
      <SelectContent className="min-w-[var(--radix-select-trigger-width)] rounded-xl px-0">
        {WORKOUT_SORT_TOKENS.map((token) => (
          <SelectItem
            key={token}
            value={token}
            hideIndicator
            className={cn(
              'justify-start rounded-lg px-3 py-2.5 text-base font-roboto font-semibold text-white',
              // Active row is filled copper instead of a check-mark; keyboard/pointer focus dims it.
              'data-[state=checked]:bg-primary data-[state=checked]:text-white',
              'data-[highlighted]:bg-primary/80 data-[highlighted]:text-white',
            )}
          >
            {SORT_LABELS[token]}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
